import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import NavigationMenu from './components/NavigationMenu';
import HomePage from './components/HomePage';
import LeaguePage from './components/LeaguePage';
import TeamComparisons from './components/TeamComparisons';
import Summary from './components/Summary';
import EloRanking from './components/EloRanking';
import PositionMatrix from './components/PositionMatrix';
import WcPositionMatrix from './components/WcPositionMatrix';
import WcSummary from './components/WcSummary';
import WcFixtures from './components/WcFixtures';
import WcCompetitionEloRanking from './components/WcCompetitionEloRanking';
import WcLeaguePage from './components/WcLeaguePage';
import WcPointThreshold from './components/WcPointThreshold';
import WcYourSimulation from './components/WcYourSimulation';
import WcStandingsCalculator from './components/WcStandingsCalculator';
import WcMatchesProbabilities from './components/WcMatchesProbabilities';
import WcBookmakerOddsComparison from './components/WcBookmakerOddsComparison';
import BlogList from './components/BlogList';
import ArticlePage from './components/ArticlePage';
import LeagueTables from './components/LeagueTables';
import SimulationResults from './components/SimulationResults';
import Fixtures from './components/Fixtures';
import YourSimulation from './components/yourSimulation';
import Login from './components/Login';
import Register from './components/Register';
import { AuthGuard } from './components/AuthGuard';
import AdminPanel from './components/AdminPanel';
import AddMatch from './components/AddMatch';
import ManageSimulations from './components/ManageSimulations';
import CreatePost from './components/CreatePost';
import PointsThreshold from './components/PointsThreshold';
import TeamPage from './components/TeamPage';
import FixtureDifficulty from './components/FixtureDifficulty';
import CompetitionEloRanking from './components/CompetitionEloRanking'; // Nowy komponent
import AchievementRanking from './components/achievements/AchievementRanking';
import AchievementList from './components/achievements/AchievementList';
import CompetitionAccessGate from './components/CompetitionAccessGate';
import ScrollRestoration from './components/ScrollRestoration';
import TeamAnalytics from './components/TeamAnalytics';
import LeagueManager from './components/AdminPanel/LeagueManager';
import SeasonImportManager from './components/AdminPanel/SeasonImportManager';
import FriendliesManager from './components/AdminPanel/FriendliesManager';
import AppSettingsManager from './components/AdminPanel/AppSettingsManager';
import TeamsWithoutMatches from './components/AdminPanel/TeamsWithoutMatches';
import LeaguesWithoutUpcomingMatches from './components/AdminPanel/LeaguesWithoutUpcomingMatches';
import PastMatchesWithoutResults from './components/AdminPanel/PastMatchesWithoutResults';
import EloAnomalies from './components/AdminPanel/EloAnomalies';
import StandingsCalculator from './components/StandingsCalculator';
import Playoff from './components/Playoff';
import LiveSimulation from './components/LiveSimulation';
import PstrykPage from './components/PstrykPage';
import ScenarioLab from './components/ScenarioLab';
import BillingCheckoutPage from './components/BillingCheckoutPage';
import BillingResultPage from './components/BillingResultPage';
import VipTeaser from './components/VipTeaser';
import SubscriptionPage from './components/SubscriptionPage';
import { HelmetProvider } from 'react-helmet-async';
import { darkTheme } from './components/theme';
import { CompetitionProvider } from './components/CompetitionContext';

function App() {
    console.log('App rendered');
    return (
        <ThemeProvider theme={darkTheme}>
            <CompetitionProvider>
                <BrowserRouter>
                    <Box sx={{ minHeight: '100vh', background: darkTheme.palette.background.default }}>
                        <header style={{ textAlign: 'center', padding: '20px 0' }}>
                            <Typography variant="h1" sx={{ fontSize: { xs: '2rem', md: '3rem' } }}>
                                SYMULIGA.PL
                            </Typography>
                            <Typography variant="body1" sx={{ fontSize: '1.2rem', mb: 2 }}>
                                Symulator polskich lig piłkarskich
                            </Typography>
                        </header>

                        <NavigationMenu />

                        <Box sx={{ padding: { xs: '5px', md: '20px' } }}>
							<ScrollRestoration />
                            <Routes>
                                <Route path="/" element={<HomePage />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/register" element={<Register />} />
                                <Route path="/vip" element={<VipTeaser />} />
                                <Route path="/kup-vip" element={<BillingCheckoutPage />} />
                                <Route path="/billing/success" element={<BillingResultPage status="success" />} />
                                <Route path="/billing/cancel" element={<BillingResultPage status="cancel" />} />
                                <Route path="/konto/subskrypcja" element={<SubscriptionPage />} />
								<Route path="/liga/431/wcPositionMatrix" element={<WcPositionMatrix />} />
								<Route path="/liga/431/wcYourSimulation" element={<WcYourSimulation />} />
								<Route path="/liga/431/wcSummary" element={<WcSummary />} />
								<Route path="/liga/431/wcPointThreshold" element={<WcPointThreshold />} />
								<Route path="/liga/431/WcStandingsCalculator" element={<WcStandingsCalculator />} />
								<Route path="/liga/431/elo-ranking" element={<WcCompetitionEloRanking />} />
								<Route path="/liga/431/fixtures" element={<WcFixtures />} />
								<Route path="/liga/431/wcMatchesProbabilities" element={<WcMatchesProbabilities />} />
                                <Route path="/liga/:competitionId/conditions" element={<CompetitionAccessGate requirementField="stats_requirement"><ScenarioLab /></CompetitionAccessGate>} />
								<Route path="/liga/431/:slug?" element={<WcLeaguePage />} />
                                <Route path="/liga/:id/:slug?" element={<LeaguePage />} />
                                <Route path="/liga/:competitionId/positionMatrix" element={<CompetitionAccessGate requirementField="full_requirement"><PositionMatrix /></CompetitionAccessGate>} />
								<Route path="/liga/:competitionId/playoff" element={<CompetitionAccessGate requirementField="stats_requirement"><Playoff /></CompetitionAccessGate>} />
                                <Route path="/liga/:competitionId/team-comparisons" element={<CompetitionAccessGate requirementField="full_requirement"><TeamComparisons /></CompetitionAccessGate>} />
                                <Route path="/liga/:competitionId/summary" element={<CompetitionAccessGate requirementField="full_requirement"><Summary /></CompetitionAccessGate>} />
                                <Route path="/liga/:competitionId/fixtures" element={<Fixtures />} />
                                <Route path="/liga/:competitionId/points-threshold" element={<CompetitionAccessGate requirementField="full_requirement"><PointsThreshold /></CompetitionAccessGate>} />
								<Route path="/liga/:id/standingsCalculator" element={<StandingsCalculator />} />
								<Route path="/liga/:competitionId/fixture_difficulty" element={<CompetitionAccessGate requirementField="stats_requirement"><FixtureDifficulty /></CompetitionAccessGate>} />
                                <Route path="/liga/:id/leagueTables" element={<LeagueTables />} />
								<Route path="/liga/:id/live" element={<AuthGuard requiredRole="admin"><LiveSimulation /></AuthGuard>} />
                                <Route path="/liga/:id/yourSimulation" element={<CompetitionAccessGate requirementField="stats_requirement"><YourSimulation /></CompetitionAccessGate>} />
                                <Route path="/liga/:competitionId/elo-ranking" element={<CompetitionAccessGate requirementField="stats_requirement"><CompetitionEloRanking /></CompetitionAccessGate>} /> {/* Nowy route */}
								<Route path="/achievements/:category" element={<AchievementRanking />} />
								<Route path="/achievements-list" element={<AchievementList />} />
								<Route path="/team/:id/analytics" element={<TeamAnalytics />} />
								<Route path="/team/:teamId/:slug?" element={<TeamPage />} />
                                <Route path="/elo-ranking" element={<EloRanking />} />
                                <Route path="/blog" element={<BlogList />} />
                                <Route path="/blog/:slug" element={<ArticlePage />} />
                                <Route path="/simulation-results" element={<SimulationResults />} />
                                <Route path="/pstryk" element={<PstrykPage />} />
                                <Route path="/janekjot" element={<AuthGuard requiredRole="admin"><AdminPanel /></AuthGuard>} />
                                <Route path="/janekjot/addMatch" element={<AuthGuard requiredRole="admin"><AddMatch /></AuthGuard>} />
                                <Route path="/janekjot/manageSimulations" element={<AuthGuard requiredRole="admin"><ManageSimulations /></AuthGuard>} />
								<Route path="/janekjot/leagueManager" element={<AuthGuard requiredRole="admin"><LeagueManager /></AuthGuard>} />
								<Route path="/janekjot/seasonImport" element={<AuthGuard requiredRole="admin"><SeasonImportManager /></AuthGuard>} />
								<Route path="/janekjot/friendlies" element={<AuthGuard requiredRole="admin"><FriendliesManager /></AuthGuard>} />
								<Route path="/janekjot/settings" element={<AuthGuard requiredRole="admin"><AppSettingsManager /></AuthGuard>} />
								<Route path="/janekjot/druzyny-bez-meczow" element={<AuthGuard requiredRole="admin"><TeamsWithoutMatches /></AuthGuard>} />
								<Route path="/janekjot/ligi-bez-najblizszych-meczow" element={<AuthGuard requiredRole="admin"><LeaguesWithoutUpcomingMatches /></AuthGuard>} />
								<Route path="/janekjot/mecze-przeszle-bez-wyniku" element={<AuthGuard requiredRole="admin"><PastMatchesWithoutResults /></AuthGuard>} />
								<Route path="/janekjot/bledne-zmiany-elo" element={<AuthGuard requiredRole="admin"><EloAnomalies /></AuthGuard>} />
								<Route path="/janekjot/createPost" element={<AuthGuard requiredRole="admin"><CreatePost /></AuthGuard>} />
								<Route path="/janekjot/odds" element={<AuthGuard requiredRole="admin"><WcBookmakerOddsComparison /></AuthGuard>} />
                                <Route path="*" element={<Typography variant="h6" sx={{ textAlign: 'center' }}>404 - Strona nie znaleziona</Typography>} />
                            </Routes>
                        </Box>

                        <footer style={{ textAlign: 'center', padding: '20px 0', backgroundColor: '#1a1a1a' }}>
                            <Typography variant="body2">
                                © 2026 SymuLiga.pl. Wszystkie prawa zastrzeżone.
                            </Typography>
                        </footer>
                    </Box>
                </BrowserRouter>
            </CompetitionProvider>
        </ThemeProvider>
    );
}

export default App;
